import { Button as BaseButton, ButtonProps, KIND, SIZE, SHAPE } from 'baseui/button';

export const Button = (props: ButtonProps) => {
    return (
        <BaseButton
            {...props}
            overrides={{
                BaseButton: {
                    style: {
                        fontFamily: '"Lora", "Times New Roman", Times, serif',
                        borderTopLeftRadius: '4px',
                        borderTopRightRadius: '4px',
                        borderBottomLeftRadius: '4px',
                        borderBottomRightRadius: '4px',
                        fontWeight: 500,
                    },
                },
                ...props.overrides,
            }}
        />
    );
};

export { KIND, SIZE, SHAPE };
